import qs from 'query-string';


export const generateItemUrl = (item) => {
    return {pathname: `/s/${item.id}`}
}


const paramsDefaults = {

    center: (value) => {
        if (!value) return { lat: 0, lng: 0 };

        const { lng, lat } = value;
        if (lng || lat) {
            return { lng: parseFloat(lng), lat: parseFloat(lat) }
        }
        return { lat: 0, lng: 0 };
    },
    zoom: (value) => value ? parseFloat(value) : 4,
    bounds: (value) => value ? value : {},

    location: (value) => value ? value : "",
    search: (value) => value ? value : "",
    remote: (value) => typeof (value) === "boolean" ? value : false,
    visa: (value) => typeof (value) === "boolean" ? value : false,

    type: (value) => value ? value : [],
    source: (value) => value ? value : [],
    category: (value) => value ? value : [],

    favorites: (value) => typeof (value) === "boolean" ? value : false,
    noted: (value) => typeof (value) === "boolean" ? value : false,

    order: (value) => value ? value : "",
    time: (value) => value ? value : "now-30d",

    polygon: (value) => value ? value : [],

    items: (value) => value ? value : [],
}

export const paramsFromUrl = (params) => {

    let obj = { ...params };

    if (obj.lat && obj.lng) {
        obj['center'] = { lng: params.lng, lat: params.lat }
    }

    obj['visa'] = params.visa ? params.visa === "true" : false;
    obj['remote'] = params.remote ? params.remote === "true" : false;
    
    obj['category'] = params.category ? (Array.isArray(params.category) ? params.category : [params.category]) : [];
    obj['type'] = params.type ? (Array.isArray(params.type) ? params.type : [params.type]) : [];
    obj['source'] = params.source ? (Array.isArray(params.source) ? params.source : [params.source]) : [];
    for (const key in paramsDefaults) {
        obj[key] = paramsDefaults[key](obj[key]);
    }

    return obj;
}




export const generateSearchUrl = (params) => {
    let query = {};

    if (params.location) {
        query['location'] = params.location;
    }

    if (params.location && params.distance) {
        query['distance'] = params.distance;
    }

    if (params.remote) {
        query['remote'] = true;
    }

    if (params.visa) {
        query['visa'] = true;
    }

    if (params.time) {
        if (params.time !== "now-30d") {
            query['time'] = params.time;
        }
    }

    if (params.search.length > 0) {
        query['search'] = params.search;
    }

    if (params.utm) {
        query['utm'] = params.utm;
    }

    if (params.order) {
        query['order'] = params.order;
    }

    if (params.category.length > 0) {
        query['category'] = params.category;
    }

    if (params.source.length > 0) {
        query['source'] = params.source;
    }

    if (params.type.length > 0) {
        query['type'] = params.type;
    }

    if (params.map === false) {
        query['map'] = false;
    }

    const { lng, lat } = params.center;

    return {
        pathname: `/search/${lat.toFixed(4)}/${lng.toFixed(4)}/${params.zoom.toFixed(4)}`,
        search: qs.stringify(query)
    }
}
